import { formatDateTime, formatDate } from "@/util";

const ExamplePage = () => {
    const dtFormatted = formatDateTime("2023-01-11T18:25:33.111Z");
    const dFormatted = "2023-01-11";

    return (
        <div>
            Example page content. {dtFormatted} {dFormatted}
        </div>
    );
};

export default ExamplePage;
